import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IOverlayerOptions } from '@dch/pxs-angular-design-system/src/lib/overlayer';

@Component({
  selector: 'my-bill-odb-usage-level-four-table-header-reorder-columns-modal',
  templateUrl:
    './odb-usage-level-four-table-header-reorder-columns-modal.component.html',
  standalone: false,
})
export class OdbUsageLevelFourTableHeaderReorderColumnsModalComponent {
  @Input() showModal: boolean;
  @Output() hideModal = new EventEmitter<boolean>();

  options: IOverlayerOptions = {
    displayCloseIcon: true,
    backDrop: true,
    closeViaBackdrop: true,
    focusOnBox: true,
  };

  closeModal(): void {
    this.hideModal.emit(true);
  }
}
